export const TerminalStepContextJustifi = ({ children }: React.PropsWithChildren<object>) => {
  return <>{children}</>;
};
